<template>
  <a-row class="!content-fix" type="flex">
    <spinner v-if="loading" />

    <a-col v-else class="height100 flex-1">
      <a-page-header
        v-if="form.title"
        :ghost="false"
        title="Блогеры о нас"
        @back="() => $router.go(-1)"
      >
        <template slot="extra" />
      </a-page-header>
      <a-tabs :key="$route.fullPath" class="!main-tabs" type="card">
        <a-tab-pane key="content">
          <span slot="tab"> <a-icon type="project" />Содержимое </span>

          <!-- lang tabs -->
          <a-row align="middle" class="flex-baseline input-form__group">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Язык:
            </a-col>
            <a-col :span="12">
              <!-- lang translit tabs -->
              <a-row align="middle" class="flex-baseline flex-wrap">
                <lang-tabs v-model="langTab" class="mb-1x" />
              </a-row>
            </a-col>
          </a-row>

          <!-- image -->
          <a-row align="middle" class="input-form__group">
            <a-col
              :span="6"
              style="text-align: right; padding-top: 4px; padding-right: 8px"
            >
              Фото:
            </a-col>
            <a-col :span="12">
              <a-row align="top" type="flex">
                <a-avatar
                  :size="86"
                  :src="ccimage"
                  icon="user"
                  shape="square"
                />

                <input
                  ref="imageInputRef"
                  accept="image/jpeg, image/png"
                  hidden
                  type="file"
                  @change="handleimage"
                />
                <a-button class="ml-1x" @click="showModal(true)">
                  Выбрать
                </a-button>

                <a-button class="ml-1x" @click="removeimage">
                  Удалить
                </a-button>
              </a-row>
              <!--              <div class="error-text" v-if="!$v.image.required">-->
              <!--                Выберите изображение.-->
              <!--              </div>-->
            </a-col>
          </a-row>

          <!-- full name -->
          <a-row align="middle" class="flex-baseline input-form__group">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Ф.И.О:
            </a-col>
            <a-col :span="12">
              <a-input
                v-model.trim="form.full_name[langTab]"
                placeholder="Введите Ф.И.О"
              />
            </a-col>
          </a-row>
          <a-row align="middle" class="flex-baseline input-form__group">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              BIO:
            </a-col>
            <a-col :span="12">
              <a-input
                v-model.trim="form.bio[langTab]"
                placeholder="Введите Ф.И.О"
              />
            </a-col>
          </a-row>
          <!-- editor -->
          <a-row align="middle" class="input-form__group">
            <a-col
              :span="6"
              style="padding-top: 4px; text-align: right; padding-right: 8px"
            >
              Прочее:
            </a-col>
            <a-col :span="24">
              <editor
                :key="'tinymce_' + langTab"
                v-model="form.quote[langTab]"
                :init="{
                  height: 450,
                  plugins: [
                    'advlist autolink lists link image imagetools charmap print preview',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code wordcount'
                  ],
                  fontsize_formats:
                    '8px 10px 12px 14px 16px 18px 24px 36px 40px 72px',
                  toolbar:
                    'undo redo | preview fullscreen | formatselect fontsizeselect | bold italic underline forecolor | \
                  image link table insertfile code | hr alignleft aligncenter alignright alignjustify | \
                  bullist numlist outdent indent | removeformat',
                  language: 'ru',
                  language_url: '/js/tinymce/langs/ru.js',
                  menubar: false,
                  images_upload_url: false,
                  automatic_uploads: false,
                  relative_urls: false,
                  images_reuse_filename: true,
                  images_dataimg_filter: function (img) {
                    return img.hasAttribute('internal-blob')
                  }
                }"
                api-key="3myux81vzip0v5yxik8wex3sk4vgt37xuna840e8nzco3rs5"
              />
            </a-col>
          </a-row>

          <!-- position -->
          <a-row align="middle" class="flex-baseline input-form__group">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Позиция:
            </a-col>
            <a-col :span="12">
              <a-input
                v-model.number="form.position"
                placeholder="Введите позицию"
                @keypress="isNumber"
              />
            </a-col>
          </a-row>

          <!-- status toggle -->
          <a-row class="input-form__group">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Статус:
            </a-col>
            <a-switch v-model="form.status" />
          </a-row>
          <a-row style="margin-top: 25px">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Доступность на языке {{ langTab }}
            </a-col>
            <a-switch v-model="form.lang_support[langTab]" />
          </a-row>
        </a-tab-pane>
        <template slot="tabBarExtraContent">
          <a-button
            :loading="pending"
            style="margin-left: 10px"
            type="primary"
            @click="submit"
          >
            <a-icon type="check" />
            {{ form.id ? "Сохранить" : "Добавить" }}
          </a-button>
        </template>
      </a-tabs>

      <a-row class="form-buttons__action" type="flex">
        <a-col :span="6" style="text-align: right; padding-right: 8px" />
        <a-col>
          <a-button :disabled="pending" @click="$router.go(-1)">
            <a-icon type="close" />Отмена
          </a-button>

          <a-button
            :loading="pending"
            style="margin-left: 10px"
            type="primary"
            @click="submit"
          >
            <a-icon type="check" />
            {{ form.id ? "Сохранить" : "Добавить" }}
          </a-button>
        </a-col>
      </a-row>
    </a-col>
    <osg-cropper
      v-if="showForm"
      v-model="showForm"
      :ratio-width="19"
      :ratio-height="23"
      :quality="0.9"
      @onImageSelected="setImageExtention"
      @onSetImage="getImage"
    />
  </a-row>
</template>

<script>
import Editor from "@tinymce/tinymce-vue"

import { mapActions, mapGetters } from "vuex"

const fields = {
  full_name: {
    uz: "",
    oz: "",
    en: "",
    ru: ""
  },
  position: 1,
  bio: {
    uz: "",
    oz: "",
    en: "",
    ru: ""
  },
  lang_support: {
    uz: false,
    oz: false,
    ru: false,
    en: false,
    tj: false,
    kz: false
  },
  status: true,
  image: "",
  quote: {
    uz: "",
    oz: "",
    en: "",
    ru: ""
  }
}

export default {
  components: {
    "osg-cropper": () => import("@/components/imageCrop/modalCrop"),
    editor: Editor
  },
  data: () => ({
    fileExtension: "jpeg",
    showForm: false,
    form: { ...fields },
    loading: false,
    pending: false,
    langTab: $langPrefix,
    image: null
  }),

  computed: {
    ...mapGetters("bloggers", { leadersList: "list" }),
    cimage: {
      get() {
        if (this.image) {
          return URL.createObjectURL(this.image)
        }

        if (this.form.image) {
          return this.filesUrl + this.form.image
        }

        return require("@/assets/img/no-photo-1.png")
      }
    },
    ccimage: {
      get() {
        if (this.image) {
          return URL.createObjectURL(this.image)
        }

        if (this.form.image) {
          return this.filesUrl + this.form.image
        }

        return ""
      }
    },

    isContentNull() {
      return !!(
        !this.form.content.uz &&
        !this.form.content.oz &&
        !this.form.content.ru &&
        !this.form.content.en
      )
    }
  },

  watch: {
    $route: {
      handler: "fetchData",
      immediate: true
    },
    "form.quote": {
      handler(val) {
        try {
          // this.form.language_support[ ru or other lang prefix ] = true if form.title[ lang prefix ] exists or false
          this.$set(
            this.form.language_support,
            this.langTab,
            !!val[this.langTab]
          )
        } catch (error) {
          console.log(error)
        }
      }
    }
  },
  beforeDestroy() {
    this.clearForm()
  },

  methods: {
    ...mapActions("bloggers", ["detail"]),
    clearForm() {
      // console.log('clearForm')
      this.$set(this, "form", {
        ...fields
      })
    },
    setImageExtention(e) {
      this.fileExtension = e
    },
    showModal(value) {
      this.showForm = value
    },
    handleimage(e) {
      if (e.target.files && e.target.files[0]) {
        this.image = e.target.files[0]
      }

      this.$refs.imageInputRef.value = null
    },
    urltoFile(url, filename, mimeType) {
      return fetch(url)
        .then(function (res) {
          return res.arrayBuffer()
        })
        .then(function (buf) {
          return new File([buf], filename, { type: mimeType })
        })
    },
    getImage(variable) {
      "jpeg",
        this.urltoFile(
          variable,
          this.fileExtension,
          `image/${this.fileExtension}`
        ).then((file) => {
          this.image = file
        })
    },
    removeimage() {
      this.image = null
      this.form.image = null
    },

    async fetchData() {
      this.loading = true

      this.$set(this, "form", {
        ...fields
      })

      try {
        if (this.$route.params.id) {
          const res = await this.detail(this.$route.params.id)
          console.log(res)
          if (res) {
            this.$set(this, "form", {
              ...res,
              //   full_name: (res.full_name && JSON.parse(res.full_name)) || {
              //     ...this.langKeys
              //   },
              //    bio: (res.bio && JSON.parse(res.bio)) || {
              //     ...this.langKeys
              //   },
              image: res.image_path
              //   quote: (res.quote &&
              //     JSON.parse(res.quote)) || {
              //     ...this.langKeys
              //   }
            })
          }
        }
      } catch (e) {
        console.log(e)
        this.loading = false
      }

      this.loading = false
    },
    async submit() {
      // do your submit logic here
      this.pending = true

      const f = new FormData()
      Object.keys(this.form).forEach((key) => {
        if (this.form[key] !== undefined) {
          if (!isNaN(this.form[key])) {
            f.append(key, this.form[key])
          } else {
            if (key === "phone" || key === "image") {
              // if(this.form[key] !== null){
              f.append(key, this.form[key])
              // }
            } else {
              f.append(key, JSON.stringify(this.form[key]))
            }
          }
        }
      })
      if (this.image) {
        f.append("image", this.image)
      } else if (!this.form.image && this.form.id) {
        this.Deleteimage()
      } else {
        f.append("image", JSON.stringify(this.form["image"]))
      }

      try {
        const res = await this.$store.dispatch(
          `bloggers/${this.form.id ? "update" : "create"}ItemAction`,
          {
            id: this.form.id || null,
            data: f
          }
        )

        if (res && res.data && res.data.id) {
          this.$message.success("Успешно сохранено")
          this.$router.go(-1)
        }
      } catch (e) {
        console.log(e)
        this.pending = false
      }

      this.pending = false
    },
    async Deleteimage() {
      try {
        const res = await this.$store.dispatch(
          `bloggers/Deleteimage`,
          this.form.id
        )

        if (res) {
          this.$message.success("Успешно удалено")
          this.pending = false
        }
      } catch (e) {
        console.log(e)
        this.pending = false
      }
    }
  }
}
</script>
